import React from 'react';
import { motion } from 'framer-motion';
export function ValueTable() {
  return <section className="w-full bg-[#1B2A4A] text-white py-10 lg:py-24" data-id="element-284">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-286">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-white" data-id="element-287">
            Mira Todo Lo Que Recibes Hoy:
          </h2>

          <div className="bg-white rounded-2xl overflow-hidden shadow-2xl" data-id="element-288">
            <table className="w-full text-left border-collapse" data-id="element-289">
              <thead data-id="element-290">
                <tr className="bg-[#F7F5F0] border-b-2 border-gray-200" data-id="element-291">
                  <th className="py-4 px-6 font-bold text-[#1B2A4A] text-lg" data-id="element-292">
                    Lo Que Recibes
                  </th>
                  <th className="py-4 px-6 font-bold text-[#1B2A4A] text-lg text-right" data-id="element-293">
                    Valor Real
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-800" data-id="element-294">
                <tr className="border-b border-gray-100" data-id="element-295">
                  <td className="py-4 px-6 font-medium" data-id="element-296">
                    Ciudadanía USA Guía Exprés 2026 (PDF)
                  </td>
                  <td className="py-4 px-6 text-right text-gray-500 line-through" data-id="element-297">
                    $47 USD
                  </td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-298">
                  <td className="py-4 px-6 font-medium" data-id="element-299">
                    Bonus #1: Preguntas Actualizadas 2026 — Banco Bilingüe de
                    Preguntas y Respuestas Precisas
                  </td>
                  <td className="py-4 px-6 text-right text-gray-500 line-through" data-id="element-300">
                    $17 USD
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-301">
                  <td className="py-4 px-6 font-medium" data-id="element-302">
                    Bonus #2: Preguntas Actualizadas 2026 — Audio Bilingüe de
                    Práctica con Voz Nativa
                  </td>
                  <td className="py-4 px-6 text-right text-gray-500 line-through" data-id="element-303">
                    $27 USD
                  </td>
                </tr>
                <tr className="bg-gray-50" data-id="element-304">
                  <td className="py-4 px-6 font-bold text-[#1B2A4A]" data-id="element-305">
                    VALOR TOTAL
                  </td>
                  <td className="py-4 px-6 text-right font-bold text-[#1B2A4A] line-through" data-id="element-306">
                    $91 USD
                  </td>
                </tr>
                <tr className="bg-[#C9A84C]" data-id="element-307">
                  <td className="py-6 px-6 font-bold text-[#1B2A4A] text-xl" data-id="element-308">
                    TU PRECIO HOY
                  </td>
                  <td className="py-6 px-6 text-right font-bold text-[#1B2A4A] text-2xl" data-id="element-309">
                    $6.99 USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}